import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header flex flex-row items-center gap-2" }
const _hoisted_2 = { class: "gordita-medium-500-16 text-Text/text_high" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';

type Props = {
  title: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-performance-metrics-block',
  props: {
    title: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-performance-metrics-block bg-System/app_white flex flex-col gap-4 rounded-lg border border-system-app-border p-4" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
        _renderSlot(_ctx.$slots, "extra-header")
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})